export const COLORS = {
  primary: '#0A2463',
  secondary: '#D4AF37',
  accent: '#1E3A5F',
  neutral: {
    dark: '#2C3E50',
    medium: '#6B7280',
    light: '#F8F9FA',
    white: '#FEFEFE'
  },
  background: {
    main: '#FFFFFF',
    light: '#F8F9FA',
    dark: '#0A2463'
  },


  
  bg_institut: {
    main: '#1d70b7',
    light: '#F8F9FA',
    dark: '#ff7b22'
  },
};

// Export also as 'colors' for backward compatibility
export const colors = COLORS;
